import { createStore } from "vuex";
import richiedente from "@/store/modules/richiedente";
import volo from "@/store/modules/volo";
import compilazione from "@/store/modules/compilazione";
import passeggeri from "@/store/modules/passeggeri";
import gtmstate from "@/store/modules/gtmstate";
export default createStore(
    {
        modules : {
            richiedente,
            volo,
            compilazione,
            passeggeri,
            gtmstate
        }
    }
)